import { render } from "./EditModuleConfiguration.vue?vue&type=template&id=773f60f0&scoped=true"
import script from "./EditModuleConfiguration.vue?vue&type=script&lang=js"
export * from "./EditModuleConfiguration.vue?vue&type=script&lang=js"

import "./EditModuleConfiguration.vue?vue&type=style&index=0&id=773f60f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773f60f0"]])

export default __exports__